angular.module('tgaAdmin').config(['localStorageServiceProvider',
  function (localStorageServiceProvider) {
    // making sure the local storage is prefixed to avoid conflict with other
    // localStorage and cookies
    localStorageServiceProvider.setPrefix('tgaAdmin');
  },
]);
